import { useList } from '../../../api/react-query';

export function useConfigById({ params }) {
  const { data, isLoading, refetch } = useList(
    'config/typesById',
    { ...params },
    '',
    'v1',
  );
  return {
    data: data?.data?.data,
    isLoading,
    count: data?.data?.total,
    refetch,
  };
}
